import axios from 'axios';
import { useQuery } from 'react-query';
import useApplicationState from './useApplicationState';
var GET_CAPABILITIES_KEY = 'getCapabilities';

var getCapabilities = (serviceUrl, apiKey) => {
  if (!serviceUrl || !apiKey) return;
  return axios.request({
    method: 'get',
    params: {
      REQUEST: 'GetCapabilities'
    },
    baseURL: serviceUrl,
    headers: {
      'X-API-Key': apiKey
    }
  }).then(response => {
    return response.data;
  });
};

function useGetCapabilities(serviceUrl, options) {
  var {
    apiKey
  } = useApplicationState();
  return useQuery([GET_CAPABILITIES_KEY, serviceUrl], () => getCapabilities(serviceUrl, apiKey), options);
}

export default useGetCapabilities;